import type { SearchLocationType } from "@app/types/search-types";

// city is spelled as c1ty to force autocomplete to skip the inputs
export const AUTOCOMPLETE_INPUT_IDS = {
  origin: "origin-c1ty-input",
  destination: "destination-c1ty-input"
} as const satisfies Record<SearchLocationType, string>;

export const getAutocompleteInputId = (type: SearchLocationType): string => {
  return AUTOCOMPLETE_INPUT_IDS[type];
};
